module.exports = __webpack_public_path__ + "images/emoji/potable_water.fa3e80e3a8c02c7f84c4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/potable_water.png
// module id = f8QG
// module chunks = 24